<template>
  <div class="">
    <div
      class="contact_container"
      :class="{ 'clicked': isClicked }"
      @click="handleClick"
      @mousedown="startZoom"
      @mouseup="endZoom"
    >
      <div v-if="destinationContact" class="avatar-and-select-text">
        <img src="./profile_icon.svg" alt="Mi imagen">
        <div class="text-m-regular">{{ destinationContact.name }}</div>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="m7.5 5 5 5-5 5" stroke="#1A1A1A" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div v-else class="avatar-and-select-text">
        <!-- Avatar -->
        <img src="./profile_icon.svg" alt="Mi imagen">

        <!-- Label -->
        <div class="text-m-regular">Escoge un contacto</div>
        <svg class="svg-left" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="m7.5 5 5 5-5 5" stroke="#1A1A1A" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    destinationContact: {
      default: null
    },
  },
  data() {
    return {
      attributeIsMissing: false,
      isClicked: false
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
    startZoom() {
      this.isClicked = true
      document.addEventListener('mouseup', this.endZoom)
    },
    endZoom() {
      this.isClicked = false
      document.removeEventListener('mouseup', this.endZoom)
    }
  },
}
</script>

<style lang="scss" scoped>
.contact_container {
  overflow: hidden;
  cursor: default;
  display: flex;
  flex-direction: row;
  justify-items: center;
  padding: 16px;

  width: 100%;

  background: #FFFFFF;
  box-shadow: 0px 4px 8px rgba(26, 26, 26, 0.06);
  border-radius: 12px;
  transition: .2s;

  &:hover {
    transform: scale(1.02);
  }
  &.clicked {
    background: #eeeeee !important;
    transform: scale(0.98) !important;
  }
  .avatar-and-select-text {
    width: 100%;
    display: grid;
    grid-template-columns: 24px 1fr 20px;
    gap: 16px;
    align-items: center;
    .svg-left { justify-self: center }
    .select-text {
      // text-align: left;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #1A1A1A;

      display: -webkit-box;
      -webkit-line-clamp: 2; /* Número máximo de líneas permitidas */
      -webkit-box-orient: vertical;

      /*  white-space: nowrap; */
      overflow: hidden; /* Ocultar el texto que excede el contenedor */
      text-overflow: ellipsis;
    }
  }
}
</style>